import API from "@/API";

const SET_REQUESTER = "SET_REQUESTER";
const SET_ORDER = "SET_ORDER";
const SET_FROM_PROFESSIONAL = "SET_FROM_PROFESSIONAL";
const SET_TO_PROFESSIONAL = "SET_TO_PROFESSIONAL";
const SET_AVAILABLE_PROFESSIONALS = "SET_AVAILABLE_PROFESSIONALS";
const SET_FROM_SCHEDULE_EVENT = "SET_FROM_SCHEDULE_EVENT";
const SET_TO_SCHEDULE_EVENT = "SET_TO_SCHEDULE_EVENT";
const SET_PRELOADER = "SET_PRELOADER";

export default {
  namespaced: true,

  state: {
    preloader: false,
    requester: null,
    order: null,
    availableProfessionals: null,
    fromProfessional: null,
    toProfessional: null,
    fromScheduleEvent: null,
    toScheduleEvent: null
  },

  actions: {
    setRequester({ commit }, requester) {
      commit("SET_REQUESTER", requester);
    },
    setOrder({ commit }, order) {
      commit("SET_ORDER", order);
    },
    setFromProfessional({ commit }, professional) {
      commit("SET_FROM_PROFESSIONAL", professional);
    },
    setToProfessional({ commit }, professional) {
      commit("SET_TO_PROFESSIONAL", professional);
    },
    setFromScheduleEvent({ commit }, scheduleEvent) {
      commit("SET_FROM_SCHEDULE_EVENT", scheduleEvent);
    },
    setToScheduleEvent({ commit }, scheduleEvent) {
      commit("SET_TO_SCHEDULE_EVENT", scheduleEvent);
    },
    async searchByAvailableProfessionals({ state, commit }) {
      if (!state.order) return;
      commit("SET_PRELOADER", true);
      try {
        let res = await API.Professionals.getAvailables({
          data: {
            attributes: {
              district_id: state.order.address.district.id,
              starts_at: state.order.schedule_event.starts_at,
              ends_at: state.order.schedule_event.ends_at
            }
          }
        });
        commit("SET_AVAILABLE_PROFESSIONALS", res);
        commit("SET_PRELOADER", false);
      } catch (error) {
        commit("SET_PRELOADER", false);
        throw error;
      }
    },
    async create({ state, commit }) {
      try {
        commit("SET_PRELOADER", true);
        let res = await API.Orders.rebook(state);
        commit("SET_PRELOADER", false);
        return res;
      } catch (error) {
        commit("SET_PRELOADER", false);
        throw error;
      }
    }
  },

  mutations: {
    [SET_FROM_SCHEDULE_EVENT](state, payload) {
      state.fromScheduleEvent = payload;
    },
    [SET_TO_SCHEDULE_EVENT](state, payload) {
      state.toScheduleEvent = payload;
    },
    [SET_FROM_PROFESSIONAL](state, payload) {
      state.fromProfessional = payload;
    },
    [SET_AVAILABLE_PROFESSIONALS](state, payload) {
      state.availableProfessionals = payload;
    },
    [SET_TO_PROFESSIONAL](state, payload) {
      state.toProfessional = payload;
    },
    [SET_REQUESTER](state, payload) {
      state.requester = payload;
    },
    [SET_ORDER](state, payload) {
      state.order = payload;
    },
    [SET_PRELOADER](state, payload) {
      state.preloader = payload;
    }
  },
  getters: {}
};



// WEBPACK FOOTER //
// ./src/store/modules/orderRebooking.js